import { DayOfWeek } from '../../enums/day-of-week.enum';

export class CustomerObjectWorkingHours {
    day: DayOfWeek;
    startHour: string;
    endHour: string;
    lunchTimeStart: string;
    lunchTimeEnd: string;
    isClosed: boolean;
}